import { connect } from 'react-redux'
import * as selector from '../../state/auth/selector'
import Authorization from './Authorization'

const mapStateToProps = (state, props) => {
    return {
        hasRole: selector.selectHasRole(state, props.requiredRole),
    }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Authorization)



// WEBPACK FOOTER //
// ./src/modules/security/component/auth/AuthorizationContainer.js